import React from 'react';
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import './SidebarToggle.css';

interface SidebarToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
  className?: string;
}

const SidebarToggle: React.FC<SidebarToggleProps> = ({ isCollapsed, onToggle, className = '' }) => {
  return (
    <button
      className={`sidebar-toggle ${className}`}
      onClick={onToggle}
      aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
    >
      {isCollapsed ? <HiChevronRight size={20} /> : <HiChevronLeft size={20} />}
    </button>
  );
};

export default SidebarToggle;
